"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.some");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.function.name");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var date_fns_1 = require("date-fns");

var React = __importStar(require("react"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Headline_1 = require("../../atoms/Headline");

var Icon_1 = require("../../atoms/Icon");

var IconLink_1 = require("../IconLink");

var IconLink_2 = require("../IconLink");

var Layer_1 = require("../Layer");

var _ActionMenu_1 = require("./_ActionMenu");

var ComplexTableStateful_1 = require("./ComplexTableStateful");

var ComplexTable =
/** @class */
function (_super) {
  __extends(ComplexTable, _super);

  function ComplexTable(props) {
    var _this = _super.call(this, props) || this;

    _this.onViewportChange = function (viewportSize) {
      _this.setState({
        isMobile: ComplexTable.mobileViewports.includes(viewportSize)
      });
    }; // DOWN-Arrow = Sort ASCENDING = A..Z, 0..9, earliest date .. latest date  !!
    // at first click, the sorting shall be ascending (down arrow)


    _this.handleHeadingClick = function (e, column) {
      var _a = _this.props,
          columnProperties = _a.columnProperties,
          onHeadingClick = _a.onHeadingClick,
          sortColumn = _a.sortColumn,
          isSortedAscending = _a.isSortedAscending;

      if (columnProperties[column].isSortable) {
        var isAscending = sortColumn !== column ? true : !isSortedAscending;
        var columnName = columnProperties[column].name;
        onHeadingClick(column, columnName, isAscending, e);
      }
    };

    _this.handleBodyRowClick = function (rowIndex, rowId, e) {
      if (_this.props.onBodyRowClick) {
        _this.props.onBodyRowClick(rowIndex, rowId, e);
      }
    }; // Todo: on top of the date format, shall we offer other pre-defined formattings, like currency..., float,..


    _this.formatTableColumnData = function (colData, colIndex) {
      var columnProperties = _this.props.columnProperties;
      var result;

      if (columnProperties[colIndex].formatter) {
        result = columnProperties[colIndex].formatter(colData);
      } else if (colData instanceof Date) {
        var formatString = utils_1.DateUtils.getLocaleDateFormat("short");
        result = date_fns_1.format(colData, formatString);
      } else {
        result = colData;
      }

      return result;
    };

    _this.state = {
      isMobile: ComplexTable.mobileViewports.includes(utils_1.WindowEvents.getViewportSize()),
      sortLayerOpen: false
    };
    return _this;
  }

  ComplexTable.prototype.componentDidMount = function () {
    utils_1.WindowEvents.addViewportCallback(this.onViewportChange);
  };

  ComplexTable.prototype.componentWillUnmount = function () {
    utils_1.WindowEvents.removeViewportCallback(this.onViewportChange);
  };

  ComplexTable.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        id = _a.id,
        className = _a.className,
        columnProperties = _a.columnProperties,
        tableBodyData = _a.tableBodyData,
        sortColumn = _a.sortColumn,
        isSortedAscending = _a.isSortedAscending;
    var sortLayerOpen = this.state.sortLayerOpen;
    var hasActions = tableBodyData && tableBodyData.reduce(function (acc, val) {
      return acc || val.rowActions && val.rowActions.length > 0;
    }, false);
    return React.createElement(React.Fragment, null, this.state.isMobile && columnProperties.some(function (col) {
      return col.isSortable;
    }) && React.createElement("header", {
      className: CSSPrefix_1.lsgPre + "complextable-mobile-header"
    }, React.createElement(IconLink_1.IconLink, {
      iconName: Icon_1.Icon.Names.interaction___filter01,
      onClick: function onClick() {
        return _this.setState({
          sortLayerOpen: true
        });
      }
    }, "Sortierung"), React.createElement(Layer_1.Layer, {
      closeLinkLabel: "Zurück",
      open: sortLayerOpen,
      onCloseClick: function onCloseClick() {
        return _this.setState({
          sortLayerOpen: false
        });
      },
      htmlAttrs: {
        "aria-labelledby": "layerLeftLabel",
        "aria-describedby": "layerLeftDescription"
      }
    }, React.createElement(Headline_1.H4, null, "Sortierung nach"), React.createElement(IconLink_2.IconLinkGroup, {
      direction: IconLink_2.IconLinkGroup.Directions.VERTICAL
    }, columnProperties.map(function (th, colIndex) {
      var isSortColumn = colIndex === sortColumn;
      return th.isSortable && React.createElement(IconLink_1.IconLink, {
        className: CSSPrefix_1.lsgPre + "complextable-layer-full-width-button",
        key: colIndex,
        onClick: function onClick(e) {
          return _this.handleHeadingClick(e, colIndex);
        }
      }, th.title, React.createElement(Icon_1.Icon, {
        className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "complextable-wrap-sorticon", isSortColumn && CSSPrefix_1.lsgPre + "complextable-wrap-sorticon__sort-column"]),
        name: // down arrow = isSortedAscending !
        isSortColumn && !isSortedAscending ? Icon_1.Icon.Names.interaction_arrows_arrowUp : Icon_1.Icon.Names.interaction_arrows_arrowDown
      }));
    })))), React.createElement("table", {
      id: id,
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "complextable", className])
    }, !this.state.isMobile && React.createElement("thead", {
      className: CSSPrefix_1.lsgPre + "complextable-head"
    }, React.createElement("tr", {
      className: CSSPrefix_1.lsgPre + "complextable-head-tr"
    }, React.createElement(React.Fragment, null, columnProperties.map(function (th, colIndex) {
      var isSortColumn = colIndex === sortColumn;
      return React.createElement("th", {
        key: colIndex
        /* TODO key should not be an index */
        ,
        className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "complextable-th", columnProperties[colIndex].alignRight && CSSPrefix_1.lsgPre + "complextable-th__alignright", columnProperties[colIndex].isSortable && CSSPrefix_1.lsgPre + "complextable-th__sortable", colIndex === sortColumn && CSSPrefix_1.lsgPre + "complextable-th__sorted"]),
        onClick: function onClick(e) {
          return _this.handleHeadingClick(e, colIndex);
        }
      }, React.createElement("div", {
        className: CSSPrefix_1.lsgPre + "complextable-wrap"
      }, React.createElement("div", {
        className: CSSPrefix_1.lsgPre + "complextable-wrap-label"
      }, th.title), columnProperties[colIndex].isSortable && React.createElement(Icon_1.Icon, {
        className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "complextable-wrap-sorticon", isSortColumn && CSSPrefix_1.lsgPre + "complextable-wrap-sorticon__sort-column"]),
        name: // down arrow = isSortedAscending !
        isSortColumn && !isSortedAscending ? Icon_1.Icon.Names.interaction_arrows_arrowUp : Icon_1.Icon.Names.interaction_arrows_arrowDown,
        title: !isSortColumn || !isSortedAscending ? utils_1.Localization.texts.lsg.component.ComplexTable.sortAscending : utils_1.Localization.texts.lsg.component.ComplexTable.sortDescending
      })));
    }), (this.props.onBodyRowClick || hasActions) && !this.state.isMobile && React.createElement("th", null)))), React.createElement("tbody", {
      className: CSSPrefix_1.lsgPre + "complextable-body"
    }, tableBodyData && tableBodyData.map(function (trow, rowIndex) {
      return React.createElement("tr", {
        key: rowIndex,
        className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "complextable-body-tr", _this.props.onBodyRowClick && CSSPrefix_1.lsgPre + "complextable-body-tr__clickable"]),
        onClick: function onClick(e) {
          return _this.handleBodyRowClick(rowIndex, trow.rowId, e);
        }
      }, React.createElement(React.Fragment, null, trow.rowData.map(function (td, colIndex) {
        return React.createElement("td", {
          key: colIndex,
          className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "complextable-td", columnProperties[colIndex].alignRight && CSSPrefix_1.lsgPre + "complextable-td__alignright"])
        }, _this.state.isMobile && React.createElement("span", {
          className: CSSPrefix_1.lsgPre + "complextable-inline-heading"
        }, columnProperties[colIndex].title), _this.formatTableColumnData(td, colIndex));
      }), (_this.props.onBodyRowClick || trow.rowActions) && React.createElement("td", {
        className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "complextable-td", CSSPrefix_1.lsgPre + "complextable-action-column"])
      }, React.createElement(React.Fragment, null, _this.props.onBodyRowClick && !trow.rowActions && React.createElement(Icon_1.Icon, {
        className: CSSPrefix_1.lsgPre + "complextable-body-tr-action-arrow",
        name: Icon_1.Icon.Names.interaction_arrows_chevronRight,
        size: Icon_1.Icon.Sizes.SMALL
      }), // Todo: As an alternative for the complextable-td-action-wrapper: Take a IconlinkGroup instead?
      //    -> to do this, paddings, hovereffect and wrapping must be specified in IconLinkGroup
      trow.rowActions && React.createElement(_ActionMenu_1.ComplexTableActionMenu, {
        tableActionsProperties: trow.rowActions,
        tableRowIndex: rowIndex,
        isMobile: _this.state.isMobile
      })))));
    }))));
  };

  ComplexTable.Stateful = ComplexTableStateful_1.ComplexTableStateful;
  ComplexTable.defaultProps = {
    isSortedAscending: false
  };
  ComplexTable.mobileViewports = ["sm", "xs"];
  return ComplexTable;
}(React.Component);

exports.ComplexTable = ComplexTable;